<section class="card">

    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Electronic Clearing Service (ECS)</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/ecs"> -->
          <button (click)="add()"  class="btn btn-success pull-right" [appHasPermission]="{'Url': '/register/ecslist/edit?goveva=true&email=', 'method':'put', 'menu': 'ecslist'}" class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
    <!-- <div class="col-lg-12" id=""> -->
  
  
    <!-- <div class="tab-content"> -->
    <!-- <div class="tab-pane active" role="tabcard"> -->
    <!-- <div class="modal-body"> -->
    <!-- Date Filter  -->
    <section class="card search-box">
      <div class="card-header"  (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
            class="fa fa-filter" aria-hidden="true"></i></span> </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
  
            <!-- <form > -->
            <div class="row">
              <div class="col-md-3">
                <label>Name of Bank</label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="nameOfBank">
                </div>
                <br>
              </div>
  
              <div class="col-md-3">
                <!-- <label>Date of BM in Which ECS Facility Adopted</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From:&nbsp;
                  <input id="dateOfBM" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfBM" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfBM">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div>
  
              <div class="col-md-3">
                
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                 To:&nbsp;
                  <input id="dateOfBMTo" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfBMTo" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfBMTo">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
              <div class="col-sm-2 col-lg-2 col-md-2">
                <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                <br>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
  
            </div>
            <!-- </form> -->
  
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfEcs" [dtTrigger]="dtTriggerMasterDirector"
                class="table table-hover compact cell-border nowrap stripe" id="ecsListTable" style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Name of the Bank</th>
                    <th>Type of Account</th>
                    <th>Bank Account Number</th>
                    <th>Date of BM in Which ECS <br>Facility Adopted</th>
                    <th style="display: none">Date of BM in Which ECS Facility Adopted</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let director of registerDirectorList;let i=index">
                    <td tabindex="1">{{director.nameofbank}}</td>
                    <td tabindex="1">{{director.typeofaccount}}</td>
                    <td tabindex="1">{{director.bankaccountnumber}}</td>
                    <td tabindex="1">
                      <span style="display: none">{{director.dateOfBM | date : "yMMdd"}}</span>
                      {{director.dateOfBM | date : "dd-MM-y" }}</td>
                    <td tabindex="1" style="display: none">
                      {{director.dateOfBM | date : "dd-MM-y" }}</td>
                    <td style='white-space: nowrap'>
                      <a>
                        <button type="button" (click)="editEcsdetail(director._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/ecslist/edit?goveva=true&email=', 'method':'put', 'menu': 'ecslist'}">
                          <span class="fa fa-pencil"></span>
                        </button>
                      </a>
                      <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)" [appHasPermission]="{'Url': '/register/ecslist/edit?goveva=true&email=', 'method':'put', 'menu': 'ecslist'}">
                        <span class="icmn-bin"></span>
                        
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- </div> -->
    <!-- </div> -->
  
  
  
    <!-- </div> -->
  
  </section>
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete Electronic Clearing Service (ECS) details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deleteInvestment()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-alert></app-alert>